import { render, staticRenderFns } from "./AlbumMaster.vue?vue&type=template&id=be56dfa0&scoped=true"
import script from "./AlbumMaster.vue?vue&type=script&lang=js"
export * from "./AlbumMaster.vue?vue&type=script&lang=js"
import style0 from "./AlbumMaster.vue?vue&type=style&index=0&id=be56dfa0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be56dfa0",
  null
  
)

export default component.exports